<pages-container
  [title]="'main.tasks'"
  [icon]="'list'"
  [showSearch]="true"
  (onSearchSent)="handleSearch($event)">
  <div buttons>
    <button mat-raised-button class="mat-white-bg" (click)="addTaskGroup()">
      {{ 'main.add' | translate }}
    </button>
  </div>

  <div main-content class="task-groups">
    @for (group of taskGroups(); track group.id) {
      <div class="group-row">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="name">{{ group.title }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @for (task of group.task; track task.id) {
              <div class="task-row">
                <div class="task-details">
                  <div class="name">{{ task.title }}</div>
                  @if (task.description) {
                    <div class="task-description">{{ task.description }}</div>
                  }
                  @if (task.deadline) {
                    <div class="task-deadline">{{ 'taskGroup.deadline' | translate }}: {{ task.deadline | date: 'dd.MM.yyyy HH:mm' }}</div>
                  }
                </div>
                <div class="actions">
                  <button mat-icon-button (click)="editTask(task, group.id)"
                          [attr.aria-label]="'taskGroup.edit_task' | translate">
                    <mat-icon class="edit-icon">edit</mat-icon>
                  </button>
                </div>
              </div>
            }

            <button mat-raised-button class="add-task" (click)="addTask(group.id)">
              {{ 'taskGroup.new_task' | translate }}
            </button>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="actions">
          <button mat-icon-button (click)="editTaskGroup(group)"
                  [attr.aria-label]="'taskGroup.edit_group' | translate">
            <mat-icon class="edit-icon">edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteTaskGroup(group)"
                  [attr.aria-label]="'Delete' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    } @empty {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
